import React, { useContext, useCallback, useState } from 'react';
import { FaxProvider } from '@mummssoftware/common-ui';
import { getSiteFaxList } from '@mummssoftware/utils/pimReader';
import { isAgencyEnabled, getUserName } from '@mummssoftware/utils/utils';
import { AppContext } from '../App/AppContext';

export function CertFaxProvider({ children }) {
  const { agency, keycloak, currentUser } = useContext(AppContext);
  const [siteFaxList, setSiteFaxList] = useState(null);

  const fetchFaxList = useCallback(async () => {
    if (!agency || !keycloak) return;
    const response = await getSiteFaxList(agency, keycloak);
    if (!(response instanceof Response)) {
      setSiteFaxList(response);
    }
  }, [agency, keycloak]);

  // Fax is enabled when window.env.faxAgency matches current user's hospice bin (or is '*').
  // If faxAgency is not set (e.g. in some DocLink envs), Fax option is hidden in the UI.
  const isFaxEnabled = !!isAgencyEnabled(window.env?.faxAgency, currentUser);
  const getSenderName = useCallback(() => getUserName(currentUser), [
    currentUser,
  ]);

  const config = {
    siteFaxList,
    fetchFaxList,
    isFaxEnabled,
    getSenderName,
  };

  return <FaxProvider config={config}>{children}</FaxProvider>;
}
